<template>
  <nav v-if="isAuth" class="top-nav">
    <div class="nav-container">
      <!-- Logo -->
      <div class="nav-logo">
        <router-link :to="{ name: 'Main' }" class="logo-link">
          <img :src="require('@/assets/img/logo.svg')" alt="Logo" class="logo-img">
        </router-link>
      </div>

      <!-- Main Navigation -->
      <ul class="nav-menu" v-if="isAuth && client.email != null">
        <li class="nav-item">
          <router-link :to="{ name: 'Main' }" class="nav-link">
            <i class="fa fa-home"></i>
            Конструктор
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'order' }" class="nav-link">
            <i class="fa fa-shopping-cart"></i>
            Замовлення
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'Products' }" class="nav-link">
            <i class="fa fa-box"></i>
            Вироби
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/help" class="nav-link">
            <i class="fa fa-question-circle"></i>
            Допомога
          </router-link>
        </li>

      </ul>

      <!-- User Menu -->
      <div class="user-menu" v-if="isAuth && client.email != null">
        <div class="user-trigger" @click="toggleUserMenu" :class="{ active: userMenuOpen }">
          <div class="user-avatar">
            {{ userInitials }}
          </div>
          <span class="user-email">{{ client.email }}</span>
          <i class="fa fa-chevron-down" :class="{ rotated: userMenuOpen }"></i>
        </div>

        <div class="user-dropdown" v-show="userMenuOpen">
          <router-link :to="{ name: 'Settings', hash: '#config' }" class="dropdown-link" @click="closeUserMenu">
            <i class="fa fa-cog"></i>
            Налаштування
          </router-link>
          <router-link :to="{ name: 'Settings', hash: '#password' }" class="dropdown-link" @click="closeUserMenu">
            <i class="fa fa-key"></i>
            Зміна паролю
          </router-link>
          <div class="dropdown-divider"></div>
          <a href="#" @click.prevent="logout" class="dropdown-link">
            <i class="fa fa-sign-out-alt"></i>
            Вийти
          </a>
        </div>
      </div>

      <!-- Mobile Toggle -->
      <button class="mobile-toggle" @click="toggleMobileMenu" v-if="isAuth && client.email != null">
        <i class="fa fa-bars" v-if="!mobileMenuOpen"></i>
        <i class="fa fa-times" v-else></i>
      </button>
    </div>

    <!-- Mobile Menu -->
    <div class="mobile-menu" v-if="mobileMenuOpen && isAuth && client.email != null">
      <router-link :to="{ name: 'Main' }" class="mobile-link" @click="closeMobileMenu">
        <i class="fa fa-home"></i>
        Конструктор
      </router-link>
      <router-link :to="{ name: 'order' }" class="mobile-link" @click="closeMobileMenu">
        <i class="fa fa-shopping-cart"></i>
        Замовлення
      </router-link>
      <router-link :to="{ name: 'Products' }" class="mobile-link" @click="closeMobileMenu">
        <i class="fa fa-box"></i>
        Вироби
      </router-link>
      <router-link to="/help" class="mobile-link" @click="closeMobileMenu">
        <i class="fa fa-question-circle"></i>
        Допомога
      </router-link>

      <div class="mobile-user-section">
        <div class="mobile-user-info">
          <div class="mobile-avatar">{{ userInitials }}</div>
          <span>{{ client.email }}</span>
        </div>
        <router-link :to="{ name: 'Settings' }" class="mobile-link" @click="closeMobileMenu">
          <i class="fa fa-cog"></i>
          Налаштування
        </router-link>
        <router-link :to="{ name: 'Settings' }" class="mobile-link" @click="closeMobileMenu">
          <i class="fa fa-key"></i>
          Зміна паролю
        </router-link>
        <a href="#" @click.prevent="logout" class="mobile-link">
          <i class="fa fa-sign-out-alt"></i>
          Вийти
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      userMenuOpen: false,
      mobileMenuOpen: false
    }
  },
  computed: {
    isAuth() {
      return this.$store.state.auth.authenticated;
    },
    client() {
      return this.$store.state.auth.user;
    },
    userInitials() {
      if (!this.client?.email) return 'U';
      return this.client.email.charAt(0).toUpperCase();
    }
  },
  methods: {
    ...mapActions({
      signOut: "auth/logout"
    }),
    toggleUserMenu() {
      this.userMenuOpen = !this.userMenuOpen;
    },
    closeUserMenu() {
      this.userMenuOpen = false;
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    },
    async logout() {
      this.closeUserMenu();
      await axios.get('/logout').then(() => {
        this.signOut()
        this.$router.push({ name: "login" })
      })
    }
  },
  mounted() {
    // Close menus when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.userMenuOpen = false;
        this.mobileMenuOpen = false;
      }
    });
  }
}
</script>

<style scoped>
.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
  height: 70px;
}

/* Logo */
.nav-logo {
  flex-shrink: 0;
}

.logo-link {
  display: block;
}

.logo-img {
  height: 40px;
  width: auto;
}

/* Main Navigation */
.nav-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 1rem;
  flex: 1;
  justify-content: center;
}

.nav-item {
  position: relative;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  color: #495057;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  font-weight: 500;
  transition: all 0.2s ease;
}

.nav-link:hover {
  color: #ff182d;
  border-bottom-color: rgba(255, 24, 45, 0.5);
  text-decoration: none;
}

.nav-link.router-link-exact-active {
  color: #dc3545;
  border-bottom-color: #ff182d;
  font-weight: 550;
}

.nav-link i {
  font-size: 1rem;
}

/* User Menu */
.user-menu {
  position: relative;
  flex-shrink: 0;
}

.user-trigger {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #e9ecef;
}

.user-trigger:hover,
.user-trigger.active {
  background-color: #f8f9fa;
  border-color: #ff182d;
}

.user-avatar {
  width: 32px;
  height: 32px;
  background: #ff182d;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.9rem;
}

.user-email {
  font-size: 0.9rem;
  font-weight: 500;
  color: #495057;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fa-chevron-down {
  font-size: 0.8rem;
  color: #6c757d;
  transition: transform 0.2s ease;
}

.fa-chevron-down.rotated {
  transform: rotate(180deg);
}

.user-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1000;
  margin-top: 0.5rem;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 3px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  overflow: hidden;
}

.dropdown-link {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  color: #495057;
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.dropdown-link:hover {
  background-color: #f8f9fa;
  color: #ff182d;
  text-decoration: none;
}

.dropdown-link i {
  width: 16px;
  font-size: 0.9rem;
}

.dropdown-divider {
  height: 1px;
  background-color: #e9ecef;
  margin: 0.5rem 0;
}

/* Mobile Toggle */
.mobile-toggle {
  display: none;
  background: none;
  border: 1px solid #e9ecef;
  border-radius: 3px;
  padding: 0.5rem;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-toggle:hover {
  background-color: #f8f9fa;
  border-color: #ff182d;
}

/* Mobile Menu */
.mobile-menu {
  display: none;
  background: white;
  border-top: 1px solid #e9ecef;
  padding: 1rem;
}

.mobile-link {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  color: #495057;
  text-decoration: none;
  border-radius: 3px;
  border-bottom: 2px solid transparent;
  font-weight: 500;
  margin-bottom: 0.5rem;
  transition: all 0.2s ease;
}

.mobile-link:hover {
  color: #ff182d;
  border-bottom-color: rgba(255, 24, 45, 0.5);
  text-decoration: none;
}

.mobile-link.router-link-active {
  color: #dc3545;
  border-bottom-color: #ff182d;
  text-decoration: none;
}

.mobile-user-section {
  border-top: 1px solid #e9ecef;
  margin-top: 1rem;
  padding-top: 1rem;
}

.mobile-user-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background-color: #f8f9fa;
  border-radius: 6px;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #495057;
}

.mobile-avatar {
  width: 28px;
  height: 28px;
  background: #ff182d;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.8rem;
}

/* Responsive */
@media (max-width: 991.98px) {
  .nav-container {
    padding: 0 1rem;
  }

  .nav-menu {
    display: none;
  }

  .user-menu {
    display: none;
  }

  .mobile-toggle {
    display: block;
  }

  .mobile-menu {
    display: block;
  }
}

@media (max-width: 576px) {
  .nav-container {
    height: 60px;
  }

  .logo-img {
    height: 35px;
  }

  .user-email {
    max-width: 100px;
  }
}
</style>